import styled from 'styled-components';

export const StyledQuestionInteractionBubbleTexts = styled.div`
  z-index: 103 !important;
`;
